
Object.defineProperty(Array.prototype, "lastItem", {
  value: function() {
    if (this.length === 0) {
      return null;
    }
    return this[this.length - 1];
  },
  enumerable : false,
});